import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const FingerprintContext = createContext(null);

export const useFingerprint = () => useContext(FingerprintContext);

export const FingerprintProvider = ({ children }) => {
  const [fingerprint, setFingerprint] = useState(null);

  useEffect(() => {
    const fetchFingerprint = async () => {
      try {
        let storedFingerprint = localStorage.getItem('userFingerprint');

        if (!storedFingerprint) {
          const fp = await FingerprintJS.load();
          const result = await fp.get();

          const { visitorId } = result;
          localStorage.setItem('userFingerprint', visitorId);

          storedFingerprint = visitorId;
        }

        setFingerprint(storedFingerprint);
      } catch (error) {
        console.error('Erro ao inicializar o fingerprint:', error);
      }
    };

    fetchFingerprint();
  }, []);

  return (
    <FingerprintContext.Provider value={fingerprint}>
      {children}
    </FingerprintContext.Provider>
  );
};

export default FingerprintContext;
